import { render, staticRenderFns } from "./FooterIcons.vue?vue&type=template&id=37e2d4a4&scoped=true&"
import script from "./FooterIcons.vue?vue&type=script&lang=js&"
export * from "./FooterIcons.vue?vue&type=script&lang=js&"
import style0 from "./FooterIcons.vue?vue&type=style&index=0&id=37e2d4a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e2d4a4",
  null
  
)

export default component.exports